import { IncidentDto } from '../models/incident-dto.model';
import { EmployeeVarianceManagementRow } from '../models/employee-variance-management-row.model';

/**
 * Converts a 24-hour "HH:MM" string to 12-hour "hh:mma" format expected by formatDateOfEvent.
 * e.g. "21:29" → "09:29pm", "08:00" → "08:00am"
 */
function toTwelveHourTime(hourOfIncident: string): string {
  const [hourStr, minuteStr] = hourOfIncident.split(':');
  let hours = parseInt(hourStr, 10);
  const minutes = minuteStr ?? '00';
  const period = hours >= 12 ? 'pm' : 'am';
  if (hours > 12) hours -= 12;
  if (hours === 0) hours = 12;
  return `${hours.toString().padStart(2, '0')}:${minutes}${period}`;
}

/**
 * Converts a "YYYY-MM-DD" date string to "MM/DD/YYYY" format expected by formatDateOfEvent.
 * e.g. "2026-02-04" → "02/04/2026"
 */
function toDisplayDate(dateOfIncident: string): string {
  const [year, month, day] = dateOfIncident.split('-');
  return `${month}/${day}/${year}`;
}

export function mapIncidentDtoToRow(incident: IncidentDto): EmployeeVarianceManagementRow {
  return {
    varianceStatus: incident.varianceStatus,
    'Incident #': incident.id ?? incident.incidentNumber,
    Medication: incident.medicationName,
    'Var Amt': incident.varAmount,
    UOM: incident.varUOM,
    Patient: incident.patientName,
    'Patient ID': incident.patientId,
    Date: toDisplayDate(incident.dateOfIncident),
    Time: toTwelveHourTime(incident.hourOfIncident),
    'Clinical Unit': incident.locationName,
    Shift: incident.shiftName,
    NormalizedMedId: incident.id,
    LocationId: Number(incident.locationId),
    ShiftId: Number(incident.shiftId),
    Guid: incident.guid,
    userId: incident.userId,
    userName: incident.userName,
    userRole: incident.userRole,
  };
}
